import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Checkbox,
  Select,
  Table,
  Spin,
  Switch
} from "antd";
// import Range from '../Images/Range.PNG';
import { Tabs } from "antd";
// import MapComponent from '../Forms/MapComponent';
// import LocationForm from '../Forms/LocationForm';
import Maps from "../Forms/Maps";
import { RangeSubmit, fmuSubmit } from "../Helper/Rangeforcasting";
import { useSelector } from "react-redux";
import Timezones from "../Components/Timezone.json";
import Plot from "react-plotly.js";

export const gutterConfig = { xs: 8, sm: 16, md: 24, lg: 32 };
const { TabPane } = Tabs;
const { Option } = Select;

export default function TraneDrm(props) {
  const [defaultOriginpoint, setdefaultOriginpoint] = useState({
    origin_street: "4146 Sierra Way",
    origin_city: "San Bernardino",
    origin_state: "California",
    origin_zip_code: "92407",
    origin_duration: "0",
  });
  const [sel, setSel] = useState("Hours");
  const [isSwitch, setIsSwitch] = useState(true);
  const [seldistance, setSeldistance] = useState("Kilometers");
  // console.log(isSwitch);
  // const useEffect = (summry) => {
  //   if (summry?.duration_frequency_graph) {
  //     const rawData = JSON.parse(summry.duration_frequency_graph);
  //     const data1 = Object.values(rawData);
  //     setExtractedData(data1);
  //   }
  // };
  const handleChange = (value) => {
    setSel(value);
  };
  const handleChangedistance = (value) => {
    setSeldistance(value);
  };
  const onChangeSwitch = (checked) => {
    setIsSwitch(checked);
  };

  // Sample data (replace with your actual data)
  let routesummry = useSelector((state) => state?.rangeForcasting?.FMU);

  const df_higher = {
    distance: routesummry?.higher[5]?.distance,
    time: routesummry?.higher[0]?.time,
    soc: routesummry?.higher[1]?.soc,
  };
  const df_expected = {
    distance: routesummry?.expected[5]?.distance,
    time: routesummry?.expected[0]?.time,
    soc: routesummry?.expected[1]?.soc,
  };
  const df_lower = {
    distance: routesummry?.lower[5]?.distance,
    time: routesummry?.lower[0]?.time,
    soc: routesummry?.lower[1]?.soc,
  };

  // console.log(sel);

  let timeProperty, trace1X, trace2X, trace3X, trace4X;
  if (sel === "Hours") {
    timeProperty = "hours";
    trace1X = df_higher?.time?.[timeProperty]?.concat(
      df_lower?.time?.[timeProperty]?.slice().reverse()
    );
    trace2X = df_higher?.time?.[timeProperty];
    trace3X = df_expected?.time?.[timeProperty];
    trace4X = df_lower?.time?.[timeProperty];
  } else if (sel === "Minutes") {
    timeProperty = "minutes";
    trace1X = df_higher?.time?.[timeProperty]?.concat(
      df_lower?.time?.[timeProperty]?.slice().reverse()
    );
    trace2X = df_higher?.time?.[timeProperty];
    trace3X = df_expected?.time?.[timeProperty];
    trace4X = df_lower?.time?.[timeProperty];
    // Define trace1X, trace2X, trace3X, trace4X accordingly
  } else if (sel === "Seconds") {
    timeProperty = "seconds";
    trace1X = df_higher?.time?.[timeProperty]?.concat(
      df_lower?.time?.[timeProperty]?.slice().reverse()
    );
    trace2X = df_higher?.time?.[timeProperty];
    trace3X = df_expected?.time?.[timeProperty];
    trace4X = df_lower?.time?.[timeProperty];
    // Define trace1X, trace2X, trace3X, trace4X accordingly
  }
  let trace1XD, trace2XD, trace3XD, trace4XD;
  trace1XD = df_higher?.distance?.[seldistance]?.concat(df_lower?.distance?.[seldistance]?.slice().reverse());
  trace2XD = df_higher?.distance?.[seldistance];
  trace3XD = df_expected?.distance?.[seldistance];
  trace4XD = df_lower?.distance?.[seldistance];
  const trace1 = {
    x: trace1X,
    y: df_higher?.soc?.concat(df_lower?.soc?.slice().reverse()),
    fill: "toself",
    fillcolor: "rgba(0,100,80,0.2)",
    line: { color: "rgba(255,255,255,0)" },
    name: "Confidence Interval",
    type: "scatter",
  };
  const trace2 = {
    x: trace2X,
    y: df_higher?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Higher CI Route",
    type: "scatter",
  };
  const trace3 = {
    x: trace3X,
    y: df_expected?.soc,
    mode: "lines",
    name: "Expected Route",
    type: "scatter",
  };
  const trace4 = {
    x: trace4X,
    y: df_lower?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Lower CI Route",
    type: "scatter",
  };
  const data1 = [trace1, trace2, trace3, trace4];

  const trace1D = {
    x: trace1XD,
    y: df_higher?.soc?.concat(df_lower?.soc?.slice().reverse()),
    fill: "toself",
    fillcolor: "rgba(0,100,80,0.2)",
    line: { color: "rgba(255,255,255,0)" },
    name: "Confidence Interval",
    type: "scatter",
  };
  const trace2D = {
    x: trace2XD,
    y: df_higher?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Higher CI Route",
    type: "scatter",
  };
  const trace3D = {
    x: trace3XD,
    y: df_expected?.soc,
    mode: "lines",
    name: "Expected Route",
    type: "scatter",
  };
  const trace4D = {
    x: trace4XD,
    y: df_lower?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Lower CI Route",
    type: "scatter",
  };
  const data1D = [trace1D, trace2D, trace3D, trace4D];

  // const trace1 = {
  //   x: df_higher?.time?.hours?.concat(df_lower?.time?.hours?.slice().reverse()),
  //   y: df_higher?.soc?.concat(df_lower?.soc?.slice().reverse()),
  //   fill: "toself",
  //   fillcolor: "rgba(0,100,80,0.2)",
  //   line: { color: "rgba(255,255,255,0)" },
  //   name: "Confidence Interval",
  //   type: "scatter",
  // };

  // const trace2 = {
  //   x: df_higher?.time?.hours,
  //   y: df_higher?.soc,
  //   mode: "lines",
  //   line: { dash: "dot" },
  //   name: "Higher CI Route",
  //   type: "scatter",
  // };

  // const trace3 = {
  //   x: df_expected?.time?.hours,
  //   y: df_expected?.soc,
  //   mode: "lines",
  //   name: "Expected Route",
  //   type: "scatter",
  // };

  // const trace4 = {
  //   x: df_lower?.time?.hours,
  //   y: df_lower?.soc,
  //   mode: "lines",
  //   line: { dash: "dot" },
  //   name: "Lower CI Route",
  //   type: "scatter",
  // };

  // const data1 = [trace1, trace2, trace3, trace4];
  const df_higher_P_load = {
    time: routesummry?.higher[0]?.time,
    soc: routesummry?.higher[2]?.P_load,
  };
  const df_expected_P_load = {
    time: routesummry?.expected[0]?.time,
    soc: routesummry?.expected[2]?.P_load,
  };
  const df_lower_P_load = {
    time: routesummry?.lower[0]?.time,
    soc: routesummry?.lower[2]?.P_load,
  };

  const trace1_P_load = {
    x: trace1X,
    y: df_higher_P_load?.soc?.concat(df_lower_P_load?.soc?.slice().reverse()),
    fill: "toself",
    fillcolor: "rgba(0,100,80,0.2)",
    line: { color: "rgba(255,255,255,0)" },
    name: "Confidence Interval",
    type: "scatter",
  };
  const trace2_P_load = {
    x: trace2X,
    y: df_higher_P_load?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Higher CI Route",
    type: "scatter",
  };
  const trace3_P_load = {
    x: trace3X,
    y: df_expected_P_load?.soc,
    mode: "lines",
    name: "Expected Route",
    type: "scatter",
  };
  const trace4_P_load = {
    x: trace4X,
    y: df_lower_P_load?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Lower CI Route",
    type: "scatter",
  };
  const data2 = [trace1_P_load, trace2_P_load, trace3_P_load, trace4_P_load];

  const trace1_P_loadD = {
    x: trace1XD,
    y: df_higher_P_load?.soc?.concat(df_lower_P_load?.soc?.slice().reverse()),
    fill: "toself",
    fillcolor: "rgba(0,100,80,0.2)",
    line: { color: "rgba(255,255,255,0)" },
    name: "Confidence Interval",
    type: "scatter",
  };
  const trace2_P_loadD = {
    x: trace2XD,
    y: df_higher_P_load?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Higher CI Route",
    type: "scatter",
  };
  const trace3_P_loadD = {
    x: trace3XD,
    y: df_expected_P_load?.soc,
    mode: "lines",
    name: "Expected Route",
    type: "scatter",
  };
  const trace4_P_loadD = {
    x: trace4XD,
    y: df_lower_P_load?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Lower CI Route",
    type: "scatter",
  };
  const data2D = [
    trace1_P_loadD,
    trace2_P_loadD,
    trace3_P_loadD,
    trace4_P_loadD,
  ];

  const layout = {
    title: "Battery SoC for the Route",
    xaxis: { title: "Time" },
    // xaxis: { title: "Distance /km" },
    yaxis: { title: "Output" },
    legend: { title: "Routes" },
  };

  const layout2 = {
    title: "Battery P_Load for the Route",
    xaxis: { title: "Time" },
    // xaxis: { title: "Distance /km" },
    yaxis: { title: "Output" },
    legend: { title: "Routes" },
  };

  const layoutD = {
    title: "Battery SoC for the Route",
    // xaxis: { title: "Time" },
    xaxis: { title: `Distance ${seldistance}` },
    yaxis: { title: "Output" },
    legend: { title: "Routes" },
  };

  const layout2D = {
    title: "Battery P_Load for the Route",
    // xaxis: { title: "Time" },
    xaxis: { title: `Distance ${seldistance}` },
    yaxis: { title: "Output" },
    legend: { title: "Routes" },
  };

  const df_higher_batt_current = {
    time: routesummry?.higher[0]?.time,
    soc: routesummry?.higher[3]?.batt_current,
  };
  const df_expected_batt_current = {
    time: routesummry?.expected[0]?.time,
    soc: routesummry?.expected[3]?.batt_current,
  };
  const df_lower_batt_current = {
    time: routesummry?.lower[0]?.time,
    soc: routesummry?.lower[3]?.batt_current,
  };

  const trace1_batt_current = {
    x: trace1X,
    y: df_higher_batt_current?.soc?.concat(
      df_lower_batt_current?.soc?.slice().reverse()
    ),
    fill: "toself",
    fillcolor: "rgba(0,100,80,0.2)",
    line: { color: "rgba(255,255,255,0)" },
    name: "Confidence Interval",
    type: "scatter",
  };
  const trace2_batt_current = {
    x: trace2X,
    y: df_higher_batt_current?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Higher CI Route",
    type: "scatter",
  };
  const trace3_batt_current = {
    x: trace3X,
    y: df_expected_batt_current?.soc,
    mode: "lines",
    name: "Expected Route",
    type: "scatter",
  };
  const trace4_batt_current = {
    x: trace4X,
    y: df_lower_batt_current?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Lower CI Route",
    type: "scatter",
  };
  const data3 = [
    trace1_batt_current,
    trace2_batt_current,
    trace3_batt_current,
    trace4_batt_current,
  ];

  const trace1_batt_currentD = {
    x: trace1XD,
    y: df_higher_batt_current?.soc?.concat(
      df_lower_batt_current?.soc?.slice().reverse()
    ),
    fill: "toself",
    fillcolor: "rgba(0,100,80,0.2)",
    line: { color: "rgba(255,255,255,0)" },
    name: "Confidence Interval",
    type: "scatter",
  };
  const trace2_batt_currentD = {
    x: trace2XD,
    y: df_higher_batt_current?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Higher CI Route",
    type: "scatter",
  };
  const trace3_batt_currentD = {
    x: trace3XD,
    y: df_expected_batt_current?.soc,
    mode: "lines",
    name: "Expected Route",
    type: "scatter",
  };
  const trace4_batt_currentD = {
    x: trace4XD,
    y: df_lower_batt_current?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Lower CI Route",
    type: "scatter",
  };
  const data3D = [
    trace1_batt_currentD,
    trace2_batt_currentD,
    trace3_batt_currentD,
    trace4_batt_currentD,
  ];

  const layout3 = {
    title: "Battery batt_current for the Route",
    xaxis: { title: "Time" },
    // xaxis: { title: "Distance /km" },
    yaxis: { title: "Output" },
    legend: { title: "Routes" },
  };

  const layout3D = {
    title: "Battery batt_current for the Route",
    // xaxis: { title: "Time" },
    xaxis: { title: `Distance ${seldistance}` },
    yaxis: { title: "Output" },
    legend: { title: "Routes" },
  };

  const df_higher_T_box = {
    time: routesummry?.higher[0]?.time,
    soc: routesummry?.higher[4]?.T_box,
  };
  const df_expected_T_box = {
    time: routesummry?.expected[0]?.time,
    soc: routesummry?.expected[4]?.T_box,
  };
  const df_lower_T_box = {
    time: routesummry?.lower[0]?.time,
    soc: routesummry?.lower[4]?.T_box,
  };

  const trace1_T_box = {
    x: trace1X,
    y: df_higher_T_box?.soc?.concat(df_lower_T_box?.soc?.slice().reverse()),
    fill: "toself",
    fillcolor: "rgba(0,100,80,0.2)",
    line: { color: "rgba(255,255,255,0)" },
    name: "Confidence Interval",
    type: "scatter",
  };
  const trace2_T_box = {
    x: trace2X,
    y: df_higher_T_box?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Higher CI Route",
    type: "scatter",
  };
  const trace3_T_box = {
    x: trace3X,
    y: df_expected_T_box?.soc,
    mode: "lines",
    name: "Expected Route",
    type: "scatter",
  };
  const trace4_T_box = {
    x: trace4X,
    y: df_lower_T_box?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Lower CI Route",
    type: "scatter",
  };
  const data4 = [trace1_T_box, trace2_T_box, trace3_T_box, trace4_T_box];

  const trace1_T_boxD = {
    x: trace1XD,
    y: df_higher_T_box?.soc?.concat(df_lower_T_box?.soc?.slice().reverse()),
    fill: "toself",
    fillcolor: "rgba(0,100,80,0.2)",
    line: { color: "rgba(255,255,255,0)" },
    name: "Confidence Interval",
    type: "scatter",
  };
  const trace2_T_boxD = {
    x: trace2XD,
    y: df_higher_T_box?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Higher CI Route",
    type: "scatter",
  };
  const trace3_T_boxD = {
    x: trace3XD,
    y: df_expected_T_box?.soc,
    mode: "lines",
    name: "Expected Route",
    type: "scatter",
  };
  const trace4_T_boxD = {
    x: trace4XD,
    y: df_lower_T_box?.soc,
    mode: "lines",
    line: { dash: "dot" },
    name: "Lower CI Route",
    type: "scatter",
  };
  const data4D = [trace1_T_boxD, trace2_T_boxD, trace3_T_boxD, trace4_T_boxD];

  const layout4 = {
    title: "Battery T_box for the Route",
    xaxis: { title: "Time" },
    // xaxis: { title: "Distance /km" },
    yaxis: { title: "Output" },
    legend: { title: "Routes" },
  };

  const layout4D = {
    title: "Battery T_box for the Route",
    // xaxis: { title: "Time" },
    xaxis: { title: `Distance ${seldistance}` },
    yaxis: { title: "Output" },
    legend: { title: "Routes" },
  };
  // const data1 = [
  //   {
  //   type: 'scatter',
  //   x: [1, 2, 3, 4, 5],
  //   y: [1, 3, 2, 4, 1],
  //   fill: 'tozeroy',
  //   name: 'Trace 1', // Trace 1
  //   },
  //   {
  //   type: 'scatter',
  //   x: [1, 2, 3, 4, 5],
  //   y: [2, 4, 3, 5, 2],
  //   fill: 'tonexty',
  //   name: 'Trace 2', // Trace 2
  //   },
  //   ];

  //   // Define your layout
  //   const layout = {
  //   title: 'Stacked Area Chart in React with Plotly',
  //   xaxis: { title: 'X-Axis' },
  //   yaxis: { title: 'Y-Axis' },
  //   stackgroup: 'one', // Stack the areas together
  //   };

  const [defaultDestinationpoint, setdefaultDestinationpoint] = useState({
    des_street: "1520 South Heard Street",
    des_city: "San Bernardino",
    des_state: "California",
    des_zip_code: "92408",
    des_duration: "30",
  });

  const [defaultBreakpoint, setdefaultBreakpoint] = useState([
    {
      street: "Templo Del Sol 136",
      city: "Riverside",
      state: "California",
      zip_code: "92507",
      duration: "30",
    },
    {
      street: "401 North Begonia Avenue",
      city: "Ontario",
      state: "California",
      zip_code: "91762",
      duration: "30",
    },
    {
      street: "1520 South Heard Street",
      city: "San Bernardino",
      state: "California",
      zip_code: "92408",
      duration: "30",
    },
  ]);

  const timeoffset = [
    "0.5 hrs",
    "1 hrs",
    "1.5 hrs",
    "2 hrs",
    "2.5 hrs",
    "3 hrs",
  ];

  const time = ["Hours", "Minutes", "Seconds"];
  const distance = ["Kilometers", "Miles"];
  const [form] = Form.useForm();
  const [attachment, setAttachment] = useState("");
  const [breakpoints, setBreakpoints] = useState(defaultBreakpoint);
  const [originpoint, setOriginpoint] = useState([defaultOriginpoint]);
  const [destinationpoint, setDestinationpoint] = useState([
    defaultDestinationpoint,
  ]);
  const [roundTrip, setRoundTrip] = useState(false);
  const [originAddress, setOriginAddress] = useState(
    "4146 Sierra Way, San Bernardino, California 92407"
  );
  const [destinationAddress, setDestinationAddress] = useState("");
  const [breakAddress, setBreakAddress] = useState([
    "401 North Begonia Avenue, Ontario, California 91762",
    "Templo Del Sol 1365, Riverside, California 92507",
    "1520 South Heard Street, San Bernardino, California 92408",
  ]);
  const [breakAddressduration, setBreakAddressDuration] = useState([
    "Address :401 North Begonia Avenue, Ontario, California 91762, Duration: 30",
    "Address :Templo Del Sol 1365, Riverside, California 92507, Duration: 30",
    "Address :1520 South Heard Street, San Bernardino, California 92408, Duration: 30",
  ]);
  const [originAddressduartion, setOriginAddressDuration] = useState([
    "Address :4146 Sierra Way, San Bernardino, California 92407, Duration: 0",
  ]);
  const [destinationAddressduartion, setDestinationAddressDuration] = useState([
    "Address :1520 South Heard Street, San Bernardino, California 92408, Duration: 30",
  ]);
  let sim = useSelector((state) => state?.rangeForcasting?.simulation?.Files);
  const [buttonloading, setButtonLoading] = useState(false);
  const [buttonloading1, setButtonLoading1] = useState(false);
  const [extractedData, setExtractedData] = useState("");
  const [loader, setLoader] = useState(false);
  // const [max_hist_count, setmax_hist_count] = useState("");
  let summry = useSelector(
    (state) => state?.rangeForcasting?.simulation?.Summary_info
  );
  const [setpoint, setSetpoint] = useState("");
  const [batterycap, setBatteryCap] = useState("");
  const [ocv, setOcv] = useState("");

  const handleInputChange = (name, value) => {
    setSetpoint(value);
  };
  const handleInputChange1 = (name, value) => {
    setBatteryCap(value);
  };
  const handleInputChange2 = (name, value) => {
    setOcv(value);
  };

  // console.log(summry?.duration_frequency_graph);

  // const useEffect = (summry) => {
  //   if (summry?.duration_frequency_graph) {
  //     const rawData = JSON.parse(summry.duration_frequency_graph);
  //     const data1 = Object.values(rawData);
  //     setExtractedData(data1);
  //   }
  // };
  useEffect(() => {
    if (summry?.duration_frequency_graph) {
      const rawData = JSON.parse(summry.duration_frequency_graph);
      const data1 = Object.values(rawData);
      setExtractedData(data1);
      // setmax_hist_count(Math?.max?.apply(null, extractedData) * 1.1);
    }
  }, [summry]);

  const dataSource = summry?.summary_table?.Duration.map((duration, index) => ({
    key: index,
    Duration: duration,
    Expected: summry?.summary_table.Expected[index],
    "Lower CI": summry?.summary_table["Lower CI"][index],
    "Upper CI": summry?.summary_table["Upper CI"][index],
  }));

  const address_lat_long_array = [];

  for (const site_name in summry?.address_lat_long) {
    // console.log(site_name);
    const site = summry?.address_lat_long[site_name];
    // console.log(site);
    const new_object = {
      site_name,
      address: site?.address,
      duration: site?.duration,
      lat: site?.lat,
      long: site?.long,
    };

    address_lat_long_array.push(new_object);
  }
  // console.log([address_lat_long_array]);
  //   // Convert blob data to URLs
  const downloadFile = (blobData, fileName) => {
    const fileURL = URL.createObjectURL(blobData);
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = fileName;
    link.click();
  };

  // Handle the download button click
  const handleDownloadClick = () => {
    // Extract blob data from the structure
    const { expected_route, lower_ci_route, upper_ci_route } = sim;

    // Convert each blob data to a file and trigger the download
    const filesToDownload = [
      { blobData: expected_route, fileName: "expected_route.csv" },
      { blobData: lower_ci_route, fileName: "lower_ci_route.csv" },
      { blobData: upper_ci_route, fileName: "upper_ci_route.csv" },
    ];

    filesToDownload.forEach((file) => {
      const { blobData, fileName } = file;
      const fileBlob = new Blob([blobData], {
        type: "application/octet-stream",
      });
      downloadFile(fileBlob, fileName);
    });
  };

  const handleReset = () => {
    setOriginpoint([
      {
        origin_street: "",
        origin_city: "",
        origin_state: "",
        origin_zip_code: "",
        origin_duration: "0",
      },
    ]);
    setDestinationpoint([]);
    setBreakpoints([]);
  };

  const onChange = (e) => {
    setRoundTrip(e.target.checked);
    if (e.target.checked) {
      setDestinationAddress(originAddress);
    } else {
      setDestinationAddress("");
    }
  };

  const addBreakpoint = () => {
    setBreakpoints([...breakpoints, {}]);
  };

  function formatAddress(addressObj) {
    return addressObj
      .map((addressObj) => {
        const { origin_street, origin_city, origin_state, origin_zip_code } =
          addressObj;
        return `${origin_street}, ${origin_city}, ${origin_state}, ${origin_zip_code}`;
      })
      .join(",");
  }

  function formatDesAddress(addressObj) {
    return addressObj
      .map((addressObj) => {
        const { des_street, des_city, des_state, des_zip_code } = addressObj;
        return `${des_street}, ${des_city}, ${des_state}, ${des_zip_code}`;
      })
      .join(",");
  }

  function formatBreakAddress(addressObj) {
    return addressObj.map(
      ({ street, city, state, zip_code }) =>
        `${street}, ${city}, ${state}, ${zip_code}`
    );
  }

  function formatBreakAddresswithDuration(addressObj) {
    return addressObj.map(
      ({ street, city, state, zip_code, duration }) =>
        `Address :${street}, ${city}, ${state}, ${zip_code}, Duration: ${duration}`
    );
  }

  function formatOriginAddresswithDuration(addressObj) {
    return addressObj.map(
      ({
        origin_street,
        origin_city,
        origin_state,
        origin_zip_code,
        origin_duration,
      }) =>
        `Address :${origin_street}, ${origin_city}, ${origin_state}, ${origin_zip_code}, Duration: ${origin_duration}`
    );
  }

  function formatDestinationAddresswithDuration(addressObj) {
    return addressObj.map(
      ({ des_street, des_city, des_state, des_zip_code, des_duration }) =>
        `Address :${des_street}, ${des_city}, ${des_state}, ${des_zip_code}, Duration: ${des_duration}`
    );
  }

  const lastBreakpoint =
    breakpoints.length > 0 ? breakpoints[breakpoints.length - 1] : null;
  const lastBreakpointAddress = lastBreakpoint
    ? `${lastBreakpoint.street}, ${lastBreakpoint.city}, ${lastBreakpoint.state} ${lastBreakpoint.zip_code}`
    : "";

  const handleOriginpointChange = (index, field, value) => {
    const updatedOriginpoints = [...originpoint];
    updatedOriginpoints[index][field] = value;
    setOriginpoint(updatedOriginpoints);
    let c = formatAddress(originpoint);
    setOriginAddress(c);
    let f = formatOriginAddresswithDuration(updatedOriginpoints);
    setOriginAddressDuration(f);
  };

  const handleDestinationpointChange = (index, field, value) => {
    const updatedDestinationpoints = [...destinationpoint];
    updatedDestinationpoints[index][field] = value;
    setDestinationpoint(updatedDestinationpoints);
    let d = formatDesAddress(destinationpoint);
    setDestinationAddress(d);
    let f = formatDestinationAddresswithDuration(updatedDestinationpoints);
    setDestinationAddressDuration(f);
  };

  const handleBreakpointChange = (index, field, value) => {
    const updatedBreakpoints = [...breakpoints];
    updatedBreakpoints[index][field] = value;
    setBreakpoints(updatedBreakpoints);
    let q = formatBreakAddress(breakpoints);
    setBreakAddress(q);
    let s = formatBreakAddresswithDuration(updatedBreakpoints);
    setBreakAddressDuration(s);
  };

  const removeBreakpoint = (index) => {
    const updatedBreakpoints = [...breakpoints];
    updatedBreakpoints.splice(index, 1);
    setBreakpoints(updatedBreakpoints);
    let q = formatBreakAddress(updatedBreakpoints);
    setBreakAddress(q);
    let s = formatBreakAddresswithDuration(updatedBreakpoints);
    setBreakAddressDuration(s);
  };
  // const [sim, setSim] = useState(false);
  // console.log(breakAddressduration.slice(0, -1));

  const handleFormSubmit = async (e) => {
    console.log(e);
    setLoader(true);
    // console.log(loader);
    setButtonLoading(true);
    const {
      t_travel,
      t_stop_doorClosed,
      t_stop_doorOpen,
      T_out_C,
      T_setpoint_C,
      BattCap_kWh,
      OCVmax,
      Simulation_time,
      time_zone,
      time_offset,
    } = e;
    const data = {
      t_travel: t_travel ? t_travel : "45",
      t_stop_doorClosed: t_stop_doorClosed ? t_stop_doorClosed : "10",
      t_stop_doorOpen: t_stop_doorOpen ? t_stop_doorOpen : "5",
      T_out_C: T_out_C ? T_out_C : "30",
      T_setpoint_C: T_setpoint_C ? T_setpoint_C : "-20",
      BattCap_kWh: BattCap_kWh ? BattCap_kWh : "24",
      OCVmax: OCVmax ? OCVmax : "48",
      Simulation_time: Simulation_time ? Simulation_time : "1800",
      originAddress: originAddressduartion,
      destinationAddress: roundTrip
        ? originAddressduartion
        : [breakAddressduration[breakAddressduration.length - 1]],
      // breakAddressduration: breakAddressduration,
      breakAddressduration: roundTrip
        ? breakAddressduration
        : breakAddressduration.slice(0, -1),
      roundTrip: roundTrip,
      // time_zone: time_zone,
      time_offset: time_offset ? time_offset : "0.5 hrs",
    };
    setLoader(true);
    setButtonLoading(true);
    let resp = await RangeSubmit(data);
    if (resp) {
      setButtonLoading(false);
      setLoader(false);
    }
  };

  const onFileChange = (target) => {
    setAttachment(target?.[0]);
    // console.log(attachment);
  };

  const columns = [
    {
      title: "Address",
      dataIndex: "address",
      align: "center",
      // style:{fontSize: '20px'}
    },
    // {
    //   title: "Duration",
    //   dataIndex: "duration",
    //   align: 'center',
    //   // width: 100,
    // },
    {
      title: "Latitude",
      dataIndex: "lat",
      align: "center",
      // width: 100,
    },
    {
      title: "Longitude",
      dataIndex: "long",
      align: "center",
      // width: 100,
    },
  ];

  const columns1 = [
    {
      title: "Duration",
      dataIndex: "Duration",
      align: "center",
    },
    {
      title: "Expected",
      dataIndex: "Expected",
      align: "center",
      // width: 100,
    },
    {
      title: "Lower CI",
      dataIndex: "Lower CI",
      align: "center",
      // width: 100,
    },
    {
      title: "Upper CI",
      dataIndex: "Upper CI",
      align: "center",
      // width: 100,
    },
  ];

  // Assuming dataString is the comma-separated string you provided
  const rows = sim?.expected_route?.trim().split("\n");
  // console.log(rows);
  const headers = rows?.[0]?.split(",");
  // console.log(headers);
  const data = rows?.slice(1)?.map((row) => {
    const values = row.split(",");
    const entry = {};
    headers.forEach((header, index) => {
      entry[header] = values[index];
    });
    return entry;
  });
  const timestamps = data?.map((entry) => entry?.index);
  const y1Values = data?.map((entry) => parseFloat(entry?.ele));
  const y2Values = data?.map((entry) => parseFloat(entry?.temp_f));
  const y3Values = data?.map((entry) => parseFloat(entry?.sri));
  // const local_time = data?.map((entry) => parseFloat(entry?.local_time));

  const local_time = data?.map((entry) => {
    const date = new Date(Date.parse(entry?.local_time));
    return date.toLocaleTimeString();
  });
  // console.log(local_time);

  const handlesubmit = async (e) => {
    // Create a FormData object to send both data and files
    const formData = new FormData();
    // Append data to the FormData
    formData.append("T_setpoint_C", setpoint ? setpoint : "-20");
    formData.append("BattCap_kWh", batterycap ? batterycap : "24");
    formData.append("OCVmax", ocv ? ocv : "48");
    // Convert data to Blobs if they are not already
    const { expected_route, lower_ci_route, upper_ci_route } = sim;
    const expected_routeBlob = new Blob([expected_route], {
      type: "application/octet-stream",
    });
    const lower_ci_routeBlob = new Blob([lower_ci_route], {
      type: "application/octet-stream",
    });
    const upper_ci_routeBlob = new Blob([upper_ci_route], {
      type: "application/octet-stream",
    });
    // Append files to the FormData

    formData.append("expected_route", expected_routeBlob, "expected_route.csv");
    formData.append("lower_ci_route", lower_ci_routeBlob, "lower_ci_route.csv");
    formData.append("upper_ci_route", upper_ci_routeBlob, "upper_ci_route.csv");
    setButtonLoading1(true);
    let resp = await fmuSubmit(formData);
    setButtonLoading1(false);
  };

  return (
    <>
      <Sidebar>
        <Tabs type="card" defaultActiveKey="2">
          <TabPane tab="Model Info" key="1">
            FMI Version
          </TabPane>
          <TabPane tab="Inputs" key="2">
            <Form layout="vertical" form={form} onFinish={handleFormSubmit}>
              <h1
                style={{
                  paddingTop: "8px",
                  paddingBottom: "8px",
                  color: "Black",
                  background: "Lightblue",
                  outline: "2px solid black",
                  padding: "10px",
                  borderRadius: "15px",
                }}
              >
                Range Forcasting
              </h1>
              {/* <div
                style={{
                  outline: "2px solid black",
                  padding: "10px",
                  borderRadius: "15px",
                  backgroundColor: "rgb(172 221 146)",
                  marginBottom: "10px",
                }}
              >
                <Row span={24}>
                  <Col span={5}>
                    <h3>Simulation Data</h3>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      form={Form}
                      name="T_setpoint_C"
                      label={
                        <label style={{ fontSize: "20px" }}>T_setpoint_C</label>
                      }
                    >
                      <Input
                        defaultValue={"-20"}
                        style={{ height: 50, fontSize: 20 }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={2} />
                  <Col span={8}>
                    <Form.Item
                      form={Form}
                      name="BattCap_kWh"
                      label={
                        <label style={{ fontSize: "20px" }}>BattCap_kWh</label>
                      }
                    >
                      <Input
                        defaultValue={"24"}
                        style={{ height: 50, fontSize: 20 }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row span={24}>
                  <Col span={5} />
                  <Col span={8}>
                    <Form.Item
                      form={Form}
                      name="OCVmax"
                      label={<label style={{ fontSize: "20px" }}>OCVmax</label>}
                    >
                      <Input
                        defaultValue={"48V"}
                        style={{ height: 50, fontSize: 20 }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div> */}
              <div
                style={{
                  outline: "2px solid black",
                  padding: "10px",
                  borderRadius: "15px",
                  backgroundColor: "rgb(234 219 148)",
                  marginBottom: "10px",
                }}
              >
                <Row span={24}>
                  <Col span={5}>
                    <h3>Route Data</h3>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      form={Form}
                      name="time_offset"
                      label={
                        <label style={{ fontSize: "20px" }}>Time Offset</label>
                      }
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Time Offset is required",
                      //   },
                      // ]}
                    >
                      <Select defaultValue="0.5 hrs">
                        {timeoffset.map((zone) => (
                          <Option
                            key={zone}
                            value={zone}
                            style={{ fontSize: "20px" }}
                          >
                            <div style={{ fontSize: "20px" }}>{zone}</div>
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    {/* <Form.Item
                      form={Form}
                      name="time_zone"
                      label={
                        <label style={{ fontSize: "20px" }}>Time Zone</label>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Time Zone is required",
                        },
                      ]}
                    >
                      <Select>
                        {Timezones.map((zone) => (
                          <Option
                            key={zone.value}
                            value={zone.text}
                            style={{ fontSize: "20px" }}
                          >
                            <div style={{ fontSize: "20px" }}>{zone.text}</div>
                          </Option>
                        ))}
                      </Select>
                    </Form.Item> */}
                  </Col>
                  <Col span={2} />
                  <Col span={8}>
                    <Checkbox onChange={onChange} style={{ marginTop: "30px" }}>
                      {<label style={{ fontSize: "20px" }}>Round Trip</label>}
                    </Checkbox>
                  </Col>
                </Row>
                {/* <Row span={24}>
                  <Col span={5} />
                  <Col span={8}>
                    <Checkbox onChange={onChange} style={{ marginTop: "30px" }}>
                      {<label style={{ fontSize: "20px" }}>Round Trip</label>}
                    </Checkbox>
                  </Col>
                </Row> */}
                {/* // change here */}
                {/* <Row>
                  <Col span={5}/>
                    <Col>
                  <Button
                    type="primary"
                    onClick={handleReset}
                    style={{ marginLeft: "10px" }}
                  >
                    Reset Location
                  </Button>
                  </Col>
                </Row> */}
              </div>
              <div
                style={{
                  outline: "2px solid black",
                  padding: "10px",
                  borderRadius: "15px",
                  backgroundColor: "#aec9e0",
                }}
              >
                <Row>
                  <Col span={5} />
                  <h3>Address of Origin</h3>
                </Row>
                {originpoint.map((originpoint, index) => (
                  <Row span={24} key={index}>
                    {/* <Col span={4} /> */}
                    <Col span={1} />
                    <Col span={4}>
                      <Form.Item
                        form={Form}
                        name="origin_street"
                        label={
                          <label style={{ fontSize: "20px" }}>Street</label>
                        }
                      >
                        <Input
                          style={{ height: 50, fontSize: 20 }}
                          value={
                            originpoint.origin_street ||
                            defaultOriginpoint.origin_street
                          }
                          defaultValue={
                            originpoint.origin_street ||
                            defaultOriginpoint.origin_street
                          }
                          onChange={(e) =>
                            handleOriginpointChange(
                              index,
                              "origin_street",
                              e.target.value
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={1} />
                    <Col span={3}>
                      <Form.Item
                        form={Form}
                        name="origin_city"
                        label={<label style={{ fontSize: "20px" }}>City</label>}
                      >
                        <Input
                          style={{ height: 50, fontSize: 20 }}
                          value={
                            originpoint.origin_city ||
                            defaultOriginpoint.origin_city
                          }
                          defaultValue={
                            originpoint.origin_city ||
                            defaultOriginpoint.origin_city
                          }
                          onChange={(e) =>
                            handleOriginpointChange(
                              index,
                              "origin_city",
                              e.target.value
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={1} />
                    <Col span={3}>
                      <Form.Item
                        form={Form}
                        name="origin_state"
                        label={
                          <label style={{ fontSize: "20px" }}>State</label>
                        }
                      >
                        <Input
                          style={{ height: 50, fontSize: 20 }}
                          value={
                            originpoint.origin_state ||
                            defaultOriginpoint.origin_state
                          }
                          defaultValue={
                            originpoint.origin_state ||
                            defaultOriginpoint.origin_state
                          }
                          onChange={(e) =>
                            handleOriginpointChange(
                              index,
                              "origin_state",
                              e.target.value
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={1} />
                    <Col span={3}>
                      <Form.Item
                        form={Form}
                        name="origin_zip_code"
                        label={
                          <label style={{ fontSize: "20px" }}>Zip Code</label>
                        }
                      >
                        <Input
                          style={{ height: 50, fontSize: 20 }}
                          value={
                            originpoint.origin_zip_code ||
                            defaultOriginpoint.origin_zip_code
                          }
                          defaultValue={
                            originpoint.origin_zip_code ||
                            defaultOriginpoint.origin_zip_code
                          }
                          onChange={(e) =>
                            handleOriginpointChange(
                              index,
                              "origin_zip_code",
                              e.target.value
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={1} />
                    <Col span={3}>
                      <Form.Item
                        form={Form}
                        name="origin_duration"
                        label={
                          <label style={{ fontSize: "20px" }}>Duration</label>
                        }
                      >
                        <Input
                          style={{ height: 50, fontSize: 20 }}
                          value={
                            originpoint.origin_duration ||
                            defaultOriginpoint.origin_duration
                          }
                          defaultValue={
                            originpoint.origin_duration ||
                            defaultOriginpoint.origin_duration
                          }
                          onChange={(e) =>
                            handleOriginpointChange(
                              index,
                              "origin_duration",
                              e.target.value
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                ))}
              </div>
              {/* <LocationForm/> */}

              <div
                style={{
                  outline: "2px solid black",
                  padding: "10px",
                  marginTop: "10px",
                  borderRadius: "15px",
                  backgroundColor: "#aec9e0",
                }}
              >
                <Row>
                  <Col span={5} />
                  <h3>Waypoints</h3>
                </Row>
                {breakpoints?.map((breakpoint, index) => (
                  <Row key={index}>
                    <Col span={1} />
                    <Col span={4}>
                      <Form.Item
                        form={Form}
                        label={
                          <label style={{ fontSize: "20px" }}>Street</label>
                        }
                      >
                        <Input
                          style={{ height: 50, fontSize: 20 }}
                          value={breakpoint.street || defaultBreakpoint.street}
                          defaultValue={
                            originpoint.street || defaultBreakpoint.street
                          }
                          onChange={(e) =>
                            handleBreakpointChange(
                              index,
                              "street",
                              e.target.value
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={1} />
                    <Col span={3}>
                      <Form.Item
                        form={Form}
                        label={<label style={{ fontSize: "20px" }}>City</label>}
                      >
                        <Input
                          style={{ height: 50, fontSize: 20 }}
                          value={breakpoint.city || defaultBreakpoint.city}
                          defaultValue={
                            originpoint.city || defaultBreakpoint.city
                          }
                          onChange={(e) =>
                            handleBreakpointChange(
                              index,
                              "city",
                              e.target.value
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={1} />
                    <Col span={3}>
                      <Form.Item
                        form={Form}
                        label={
                          <label style={{ fontSize: "20px" }}>State</label>
                        }
                      >
                        <Input
                          style={{ height: 50, fontSize: 20 }}
                          value={breakpoint.state || defaultBreakpoint.state}
                          defaultValue={
                            originpoint.state || defaultBreakpoint.state
                          }
                          onChange={(e) =>
                            handleBreakpointChange(
                              index,
                              "state",
                              e.target.value
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={1} />
                    <Col span={3}>
                      <Form.Item
                        form={Form}
                        label={
                          <label style={{ fontSize: "20px" }}>Zip Code</label>
                        }
                      >
                        <Input
                          style={{ height: 50, fontSize: 20 }}
                          value={
                            breakpoint.zip_code || defaultBreakpoint.zip_code
                          }
                          defaultValue={
                            originpoint.zip_code || defaultBreakpoint.zip_code
                          }
                          onChange={(e) =>
                            handleBreakpointChange(
                              index,
                              "zip_code",
                              e.target.value
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={1} />
                    <Col span={3}>
                      <Form.Item
                        form={Form}
                        label={
                          <label style={{ fontSize: "20px" }}>
                            Break Durn.
                          </label>
                        }
                      >
                        <Input
                          style={{ height: 50, fontSize: 20 }}
                          value={
                            breakpoint.duration || defaultBreakpoint.duration
                          }
                          defaultValue={
                            originpoint.duration || defaultBreakpoint.duration
                          }
                          onChange={(e) =>
                            handleBreakpointChange(
                              index,
                              "duration",
                              e.target.value
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col span={1}>
                      <Button
                        onClick={() => removeBreakpoint(index)}
                        danger
                        style={{
                          marginTop: "40px",
                          marginLeft: "15px",
                          height: "50px",
                        }}
                      >
                        Remove
                      </Button>
                    </Col>
                  </Row>
                ))}
                <Row>
                  <Col span={1} />
                  <Button
                    onClick={addBreakpoint}
                    style={{ backgroundColor: "#e2c8be" }}
                  >
                    Add WayPoint
                  </Button>
                </Row>
                {/* {destinationpoint.map((destinationpoint, index) => (
        <Row span={24} key={index}>
          <Col span={1} />
          <Col span={4}>
          <Form.Item form={Form} name='des_street' label='Street'>
          <Input value={destinationpoint.des_street || defaultDestinationpoint.des_street}
                defaultValue={destinationpoint.des_street || defaultDestinationpoint.des_street}
                onChange={(e) => handleDestinationpointChange(index,'des_street', e.target.value)}/>
            </Form.Item>
          </Col>
          <Col span={1} />
          <Col span={3}>
            <Form.Item form={Form} name='des_city' label='City'>
            <Input value={destinationpoint.des_city || defaultDestinationpoint.des_city}
                 defaultValue={destinationpoint.des_city || defaultDestinationpoint.des_city}
                onChange={(e) => handleDestinationpointChange(index,'des_city', e.target.value)}/>
            </Form.Item>
          </Col>
          <Col span={1} />
          <Col span={3}>
          <Form.Item form={Form} name='des_state' label='State'>
          <Input value={destinationpoint.des_state || defaultDestinationpoint.des_state}
                defaultValue={destinationpoint.des_state || defaultDestinationpoint.des_state}
                onChange={(e) => handleDestinationpointChange(index,'des_state', e.target.value)}/>
            </Form.Item>
          </Col>
          <Col span={1} />
          <Col span={3}>
            <Form.Item form={Form} name='des_zip_code' label='Zip Code'>
            <Input value={destinationpoint.des_zip_code  || defaultDestinationpoint.des_zip_code}
                defaultValue={destinationpoint.des_zip_code || defaultDestinationpoint.des_zip_code}
                onChange={(e) => handleDestinationpointChange(index,'des_zip_code', e.target.value)}/>
            </Form.Item>
          </Col>
          <Col span={1} />
          <Col span={3}>
            <Form.Item form={Form} name='des_duration' label='Duration'>
            <Input value={destinationpoint.des_duration || defaultDestinationpoint.des_duration}
                defaultValue={destinationpoint.des_duration || defaultDestinationpoint.des_duration}
                onChange={(e) => handleDestinationpointChange(index,'des_duration', e.target.value)}/>
            </Form.Item>
          </Col>
        </Row>
           ))} */}
              </div>
              {/* <div style={{outline: '2px solid black', padding: '10px', marginTop: '10px', borderRadius: "15px"}}>
        <Row>
        <Col span={5} />
          <h3>Address of Destination</h3>
        </Row>

      
        
        </div> */}
              <Form.Item form={Form} style={{ marginTop: "10px" }}>
                <Button
                  type="primary"
                  htmlType="Simulate"
                  loading={buttonloading}
                >
                  Simulate Routes
                </Button>{" "}
                &ensp;
                <Button type="default" onClick={() => props.history.goBack(-1)}>
                  Cancel
                </Button>
                {sim && (
                  <Button
                    type="primary"
                    onClick={handleDownloadClick}
                    style={{ marginLeft: "10px" }}
                  >
                    Download Results
                  </Button>
                )}
              </Form.Item>

              {loader && (
                <Form.Item style={{ marginTop: "50px", marginBottom: "50px" }}>
                  <Spin tip="Loading Results" size="large">
                    <div className="content" />
                  </Spin>
                </Form.Item>
              )}
              <div
                style={{
                  outline: "2px solid black",
                  padding: "10px",
                  borderRadius: "15px",
                  backgroundColor: "rgb(172 221 146)",
                  marginBottom: "10px",
                }}
              >
                <Row span={24}>
                  <Col span={5}>
                    <h3>Simulation Data</h3>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      form={Form}
                      name="T_setpoint_C"
                      label={
                        <label style={{ fontSize: "20px" }}>T_setpoint_C</label>
                      }
                    >
                      <Input
                        defaultValue={"-20"}
                        style={{ height: 50, fontSize: 20 }}
                        onChange={(e) =>
                          handleInputChange("T_setpoint_C", e.target.value)
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={2} />
                  <Col span={8}>
                    <Form.Item
                      form={Form}
                      name="BattCap_kWh"
                      label={
                        <label style={{ fontSize: "20px" }}>BattCap_kWh</label>
                      }
                    >
                      <Input
                        defaultValue={"24"}
                        style={{ height: 50, fontSize: 20 }}
                        onChange={(e) =>
                          handleInputChange1("BattCap_kWh", e.target.value)
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row span={24}>
                  <Col span={5} />
                  <Col span={8}>
                    <Form.Item
                      form={Form}
                      name="OCVmax"
                      label={
                        <label style={{ fontSize: "20px" }}>OCVmax(V)</label>
                      }
                    >
                      <Input
                        defaultValue={"48"}
                        style={{ height: 50, fontSize: 20 }}
                        onChange={(e) =>
                          handleInputChange2("OCVmax", e.target.value)
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <Form.Item form={Form} style={{ marginTop: "10px" }}>
                {sim && (
                  <Button
                    type="primary"
                    onClick={handlesubmit}
                    loading={buttonloading1}
                  >
                    Simulate FMU
                  </Button>
                )}
              </Form.Item>
              {/* <div style={{ display: "flex", width: '400px'}}> */}
              {/* {sim && (
                <Plot
                  data={[
                    {
                      x: timestamps,
                      y: y1Values,
                      type: "scatter",
                      mode: "lines+markers",
                      name: "Elevation",
                      yaxis: "y1", // This associates the plot with the first y-axis
                    },
                    {
                      x: timestamps,
                      y: y2Values,
                      type: "scatter",
                      mode: "lines+markers",
                      name: "Temp_F",
                      yaxis: "y2", // This associates the plot with the second y-axis
                    },
                  ]}
                  layout={{
                    title: "TimeStep v/s Elevation v/s Temp_F",
                    xaxis: { title: "TimeStep" },
                    yaxis: { title: "Elevation", side: "left" },
                    yaxis2: { title: "Temp_F", overlaying: "y", side: "right" },
                  }}
                />
              )}
              {sim && (
                <Plot
                  data={[
                    {
                      x: timestamps,
                      y: y3Values,
                      type: "scatter",
                      mode: "lines+markers",
                      name: "Elevation",
                      yaxis: "y1", // This associates the plot with the first y-axis
                    },
                  ]}
                  layout={{
                    title: "TimeStep v/s SRI",
                    xaxis: { title: "TimeStep" },
                    yaxis: { title: "SRI", side: "left" },
                  }}
                />
              )}
              {sim && (
                <>
                  <Table
                    dataSource={address_lat_long_array}
                    columns={columns}
                  />
                  <Table dataSource={dataSource} columns={columns1} />
                </>
              )}
              {extractedData && (
            <Plot
            data={[
              { x: extractedData, type: "histogram" },
              {
                x: [summry?.upper_min, summry?.upper_min],
                y: [0, Math?.max?.apply(null, extractedData) * 1.1],
                type: "scatter",
                mode: "lines",
                line: { color: "red", width: 3 },
              },
              {
                x: [summry?.mean, summry?.mean],
                y: [0, Math?.max?.apply(null, extractedData) * 1.1],
                type: "scatter",
                mode: "lines",
                line: { color: "blue", width: 3 },
              },
              {
                x: [summry?.lower_min, summry?.lower_min],
                y: [0, Math?.max?.apply(null, extractedData) * 1.1],
                type: "scatter",
                mode: "lines",
                line: { color: "green", width: 3 },
              },
            ]}
            layout={{
              width: 500,
              height: 400,
              title:
                "Total Duration distribution with Upper and Lower limits",
              xaxis: { title: "Trip Duration (Minutes)" },
              yaxis: { title: "Relative Frequency" },
            }}
          />
              )} */}

              <Maps
                roundTrip={roundTrip}
                originAddress={
                  roundTrip ? originAddress : formatAddress(originpoint)
                }
                // breakAddress = {breakAddress? breakAddress : formatBreakAddress(breakpoints)}
                breakAddress={
                  roundTrip
                    ? breakAddress
                    : formatBreakAddress(breakpoints.slice(0, -1))
                }
                destinationAddress={
                  roundTrip ? originAddress : lastBreakpointAddress
                }
              />
            </Form>
            {/* {sim && (
      <Image
      width={400}
      src = {Range}
      />
      )} */}
          </TabPane>
          <TabPane tab="Route Results" key="3">
            {sim && (
              <Plot
                data={[
                  {
                    x: local_time,
                    y: y1Values,
                    type: "scatter",
                    mode: "lines",
                    name: "Elevation",
                    yaxis: "y1", // This associates the plot with the first y-axis
                  },
                  {
                    x: local_time,
                    y: y2Values,
                    type: "scatter",
                    mode: "lines",
                    name: "Temp_F",
                    yaxis: "y2", // This associates the plot with the second y-axis
                  },
                ]}
                layout={{
                  title: "local_time v/s Elevation v/s Temp_F",
                  // xaxis: { title: "local_time"},
                  yaxis: { title: "Elevation", side: "left" },
                  yaxis2: { title: "Temp_F", overlaying: "y", side: "right" },
                  automargin: true,
                }}
              />
            )}
            {sim && (
              <Plot
                data={[
                  {
                    x: local_time,
                    y: y3Values,
                    type: "scatter",
                    mode: "lines+markers",
                    name: "Elevation",
                    yaxis: "y1", // This associates the plot with the first y-axis
                  },
                ]}
                layout={{
                  title: "LocalTime v/s SRI",
                  // xaxis: { title: "TimeStep" },
                  yaxis: { title: "SRI", side: "left" },
                }}
              />
            )}
            {sim && (
              <>
                <Table
                  dataSource={address_lat_long_array}
                  columns={columns}
                  style={{ marginTop: "50px" }}
                />
                <Table dataSource={dataSource} columns={columns1} />
              </>
            )}
            {extractedData && (
              <Plot
                data={[
                  { x: extractedData, type: "histogram", name: "Data" },
                  {
                    x: [summry?.upper_min, summry?.upper_min],
                    y: [0, Math?.max?.apply(null, extractedData) * 2.1],
                    type: "scatter",
                    mode: "lines",
                    name: "Upper Limit",
                    line: { color: "red", width: 3 },
                  },
                  {
                    x: [summry?.mean, summry?.mean],
                    y: [0, Math?.max?.apply(null, extractedData) * 2.1],
                    type: "scatter",
                    mode: "lines",
                    name: "Mean",
                    line: { color: "blue", width: 3 },
                  },
                  {
                    x: [summry?.lower_min, summry?.lower_min],
                    y: [0, Math?.max?.apply(null, extractedData) * 2.1],
                    type: "scatter",
                    mode: "lines",
                    name: "Lower Limit",
                    line: { color: "green", width: 3 },
                  },
                ]}
                layout={{
                  width: 500,
                  height: 400,
                  title:
                    "Total Duration distribution with Upper and Lower limits",
                  xaxis: { title: "Trip Duration (Minutes)" },
                  yaxis: { title: "Relative Frequency" },
                }}
              />
            )}
          </TabPane>
          <TabPane tab="FMU Results" key="4">
            <div style={{ display: "flex" }}>
              <h4>Time</h4>
              <Switch defaultChecked onChange={onChangeSwitch} />
              <h4>Distance</h4>
            </div>
            { !isSwitch && (
            <><div style={{ width: "200px" }}>
                <Select
                  style={{ width: "200px" }}
                  defaultValue={"Hours"}
                  onChange={handleChange}
                >
                  {time.map((zone) => (
                    <Option key={zone} value={zone} style={{ fontSize: "20px" }}>
                      <div style={{ fontSize: "20px" }}>{zone}</div>
                    </Option>
                  ))}
                </Select>
              </div><div>
                  <Plot data={data1} layout={layout} />
                </div><div>
                  <Plot data={data2} layout={layout2} />
                </div><div>
                  <Plot data={data3} layout={layout3} />
                </div><div>
                  <Plot data={data4} layout={layout4} />
                </div></>
            )
            }
             { isSwitch && (
              <><div style={{ width: "200px" }}>
                <Select
                  style={{ width: "200px" }}
                  defaultValue={"Kilometers"}
                  onChange={handleChangedistance}
                >
                  {distance.map((zone) => (
                    <Option key={zone} value={zone} style={{ fontSize: "20px" }}>
                      <div style={{ fontSize: "20px" }}>{zone}</div>
                    </Option>
                  ))}
                </Select>
              </div><><div>
                <Plot data={data1D} layout={layoutD} />
              </div><div>
                    <Plot data={data2D} layout={layout2D} />
                  </div><div>
                    <Plot data={data3D} layout={layout3D} />
                  </div><div>
                    <Plot data={data4D} layout={layout4D} />
                  </div></></>
             )}
          </TabPane>
          <TabPane tab="Documentation" key="5">
            Documentation
          </TabPane>
        </Tabs>
      </Sidebar>
    </>
  );
}
